import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import { exchangeFacetCode } from '../services/auth';

/**
 * Facet 回调页：浏览器从 Facet 跳回时携带 ?code=&state=，
 * 前端调用后端交换 token（POST /auth/callback，由 exchangeFacetCode 封装）。
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [exchangeError, setExchangeError] = useState('');

  // 参数类错误在渲染期派生，避免在 effect 中同步 setState
  const errorParam = searchParams.get('error');
  const hasRequiredParams = Boolean(searchParams.get('code') && searchParams.get('state'));
  const paramError = errorParam
    ? `Facet 登录失败: ${errorParam}`
    : hasRequiredParams
      ? ''
      : '登录回调缺少必要参数';
  const error = paramError || exchangeError;

  useEffect(() => {
    if (paramError) return;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    if (!code || !state) return;

    exchangeFacetCode(code, state)
      .then(() => {
        window.location.href = '/';
      })
      .catch((err) => {
        const e = err as { response?: { data?: { detail?: unknown } }; message?: unknown };
        const detail = e.response?.data?.detail;
        setExchangeError(
          typeof detail === 'string'
            ? detail
            : typeof e.message === 'string'
              ? e.message
              : '登录失败'
        );
      });
  }, [searchParams, navigate, paramError]);

  return (
    <div className="auth-page">
      <div className="auth-card fade-in">
        {error ? (
          <>
            <AlertCircle size={42} style={{ color: 'var(--pg-danger)', marginBottom: 16 }} />
            <h2 className="auth-title" style={{ fontSize: 20, marginBottom: 12 }}>
              登录失败
            </h2>
            <p style={{ color: 'var(--pg-text-muted)', fontSize: 14 }}>{error}</p>
            <button className="btn btn-primary btn-block" onClick={() => navigate('/login')} style={{ marginTop: 24 }}>
              返回登录页
            </button>
          </>
        ) : (
          <>
            <Loader2 size={42} className="spin" style={{ color: 'var(--pg-accent)', marginBottom: 16 }} />
            <h2 className="auth-title" style={{ fontSize: 20, marginBottom: 12 }}>
              正在完成登录
            </h2>
            <p style={{ color: 'var(--pg-text-muted)', fontSize: 14 }}>
              请稍候，正在与 Facet 统一身份中心交换凭证...
            </p>
          </>
        )}
      </div>
    </div>
  );
}
